(() => {
  'use strict';

  const SELECTOR = '[data-minaco-article]';

  class MinacoArticleLayout {
    constructor(root) {
      this.root = root;
      this.headerGap = Number(root.dataset.headerGap) || 0;
      this.header = document.querySelector('[data-minaco-header]');
      this.resizeObserver = null;

      this.updateHeaderOffset = this.updateHeaderOffset.bind(this);

      this.updateHeaderOffset();
      window.addEventListener('resize', this.updateHeaderOffset, { passive: true });

      if (this.header && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateHeaderOffset);
        this.resizeObserver.observe(this.header);
      }

      this.prepareVideos();
    }

    updateHeaderOffset() {
      const height = this.header ? Math.ceil(this.header.getBoundingClientRect().height) : 0;
      this.root.style.setProperty('--article-header-offset', `${Math.max(0, height + this.headerGap)}px`);
    }

    prepareVideos() {
      this.root.querySelectorAll('.minaco-article__collage video').forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.loop = true;
        video.controls = false;
        const play = video.play();
        if (play && typeof play.catch === 'function') play.catch(() => {});
      });
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach((root) => {
      if (root.dataset.articleLayoutReady === 'true') return;
      root.dataset.articleLayoutReady = 'true';
      new MinacoArticleLayout(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
